import { makeObservable } from "./Observable";

export const socketContext = makeObservable();